export interface IUser {
  firstName: string;
  lastName: string;
  email: string;
  userName?: string;
  isSuperUser: boolean;
  isSalesUser: boolean;
}

export class User implements IUser {
  private readonly _firstName: string;
  private readonly _lastName: string;
  private readonly _email: string;
  private readonly _id: number;
  private readonly _userName: string;
  private readonly _isSuperUser: boolean;
  private readonly _isSalesUser: boolean;

  private constructor(firsName: string, lastName: string, email: string, userName?: string, id?: number, isSuperUser?: boolean, isSalesUser?: boolean) {
    this._firstName = firsName;
    this._lastName = lastName;
    this._email = email;
    this._userName = userName ?? '';
    this._id = id ?? 0;
    this._isSuperUser = isSuperUser ?? false;
    this._isSalesUser = isSalesUser ?? false;
  }
  public static createUser(userProps: IUser, id?: number): User {
    if (!userProps.firstName || !userProps.lastName || !userProps.email) {
      throw new Error(`User cannot be created firstName`);
    }

    return new User(userProps.firstName, userProps.lastName, userProps.email, userProps.userName, id, userProps.isSuperUser, userProps.isSalesUser);
  }
  public get firstName(): string {
    return this._firstName;
  }
  public get lastName(): string {
    return this._lastName;
  }
  public get initials(): string {
    return `${this._firstName.charAt(0)}${this._lastName.charAt(0)}`;
  }
  public get email(): string {
    return this._email;
  }
  public get userName(): string {
    return this._userName;
  }
  public get id(): number {
    return this._id;
  }

  public get isSuperUser(): boolean {
    return this._isSuperUser;
  }

  public get isSalesUser(): boolean {
    return this._isSalesUser;
  }

  public toJsonObject(): any {
    return {
      firstName: this._firstName,
      lastName: this._lastName,
      email: this._email,
      userName: this._userName,
      isSuperUser: this._isSuperUser,
      isSalesUser: this._isSalesUser
    };
  }
}
